export enum LabelPosition {
	right = "RIGHT",
	left = "LEFT",
}

export enum ToggleStyle {
	Squared = "SQUARED",
	Rounded = "ROUNDED",
}
